import {
  ItemAccessSummaryDocument,
  type ItemAccessSummaryQuery,
  ItemTeamAccessMembersDocument,
  type ItemTeamAccessMembersQuery,
  SetItemVisibilityDocument,
  ShareItemDocument,
  ShareItemTeamDocument,
  UnshareItemDocument,
} from "#app/lib/data";

import { useObjectSharing } from "./use-object-sharing";

// Item flavor of useObjectSharing — same dialog contract as
// useWorkflowSharing, against the item_share table.

const MUTATIONS = {
  share: ShareItemDocument,
  shareTeam: ShareItemTeamDocument,
  unshare: UnshareItemDocument,
  setVisibility: SetItemVisibilityDocument,
};

const selectSummary = (data: ItemAccessSummaryQuery | undefined) =>
  data?.itemAccessSummary ?? null;

// `useTeamAccessMembers` runs the roster document through the loosely typed
// seam `useObjectSharing` also uses for the id key, so the payload arrives
// untyped here and is narrowed by the document it came from.
const selectTeamMembers = (data: unknown) =>
  (data as ItemTeamAccessMembersQuery | undefined)?.itemTeamAccessMembers ?? [];

const mergePage = (
  prev: ItemAccessSummaryQuery,
  next: ItemAccessSummaryQuery,
  list: "members" | "teams",
): ItemAccessSummaryQuery => {
  const p = prev.itemAccessSummary;
  const n = next.itemAccessSummary;
  return {
    ...next,
    itemAccessSummary: {
      ...n,
      members: list === "members" ? [...p.members, ...n.members] : p.members,
      teams: list === "teams" ? [...p.teams, ...n.teams] : p.teams,
    },
  };
};

export function useItemSharing(issueId: string | null, search?: string) {
  return useObjectSharing({
    id: issueId,
    search,
    idKey: "issueId",
    summaryDocument: ItemAccessSummaryDocument,
    teamMembersDocument: ItemTeamAccessMembersDocument,
    mutations: MUTATIONS,
    selectSummary,
    selectTeamMembers,
    mergePage,
  });
}
